import home from './src/home.vue'
import ScenicCarParkManagerView from './src/ScenicCarParkManage/ScenicCarParkManagerView.vue' //停车场设备列表
import ScenicCarParkManagerEdit from './src/ScenicCarParkManage/ScenicCarParkManagerEdit.vue' //停车场设备详情
import CarRecordListView from './src/CarParkRecord/CarRecordListView.vue' //过车记录查询
import CarParkFeeRecordView from './src/CarParkFeeRecord/CarParkFeeRecordView.vue' //缴费记录查询

import CarParkAnalysisList from './src/CarParkaAnalysis/CarParkAnalysisList.vue' //停车场分析

let views = {
    home,
    ScenicCarParkManagerView,
    ScenicCarParkManagerEdit,
    CarRecordListView,
    CarParkFeeRecordView,
    CarParkAnalysisList
};

export default views;